import { z } from 'zod';

// 'Core' = per-core / capacity licensing (e.g. SQL Server, Oracle, Windows
// Datacenter) — tied to a server's cores rather than a user or device.
export const licenceTypes = ['User', 'Device', 'Core', 'Concurrent', 'Site'] as const;

// The pool owns only its identity + assignments. Seats, cost per seat, billing
// cadence and vendor live on the contract line item (migration 034).
export const softwareSchema = z.object({
  Title: z.string().trim().min(1, 'Title is required'),
  LicenceType: z.enum(licenceTypes),
  SKU: z.string().trim().optional(),
  // Numeric SKU factor for integrations that key on an int (empty → null).
  SkuId: z.number().int('SKU (ID) must be a whole number').nullable().optional(),
  // Optional Entra security group objectId (GUID). Blank = not linked; the empty
  // string is allowed so an existing link can be cleared.
  SecurityGroupId: z.string().trim().refine((v) => v === '' || z.string().uuid().safeParse(v).success, 'Enter a valid group object ID (GUID)').optional(),
  SecurityGroupName: z.string().trim().optional(),
  Notes: z.string().trim().optional(),
});

export type SoftwareFormData = z.infer<typeof softwareSchema>;
